// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9886) return "9886.28a6d77415486ed8ace4.css";
	// return url for filenames based on template
	return "" + (chunkId === 8487 ? "CategoryList" : chunkId) + "." + {"2056":"b056c7a1c2548463783b","3113":"1c91cd1e94d4f783b65a","4943":"081577002a32443aaf65","8487":"4b6210f5cea4134cea3c"}[chunkId] + ".css";
};